// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__gsaTq","total":"Cart_total__3V4ZL","actions":"Cart_actions__vpJpR","button--alt":"Cart_button--alt__2Gnn1","button":"Cart_button__34QVQ"};